import { render, staticRenderFns } from "./analysisLogisticsModal.vue?vue&type=template&id=0480c82a&scoped=true&"
import script from "./analysisLogisticsModal.vue?vue&type=script&lang=js&"
export * from "./analysisLogisticsModal.vue?vue&type=script&lang=js&"
import style0 from "./analysisLogisticsModal.vue?vue&type=style&index=0&id=0480c82a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0480c82a",
  null
  
)

export default component.exports